<template>
  <div>
    <CRow class="mt-3" v-if="cartMode">
      <CCol>
        <CCard class="sticky-top rounded">
          <CCardBody>
            <CRow alignVertical="center">
              <CCol sm="6" class="mb-2">
                <CRow><CCol sm="6" class="font-weight-bold">Vr. Mercancia:</CCol><CCol sm="6" align="right">	${{formatter.format(cart.productsCost)}}</CCol></CRow>
                <CRow><CCol sm="6" class="font-weight-bold">Vr. IVA:</CCol><CCol sm="6" align="right">	${{formatter.format(cart.IVACost)}}</CCol></CRow>
                <CRow><CCol sm="6" class="font-weight-bold">Vr. ImpConsumo:</CCol><CCol sm="6" align="right">	${{formatter.format(cart.consTax)}}</CCol></CRow>
                <CRow>
                  <CCol sm="6" class="font-weight-bold">
                    Total {{labelTitle}}:
                  </CCol>
                  <CCol sm="6" align="right">
                    <span v-if="(cart.productsCost + cart.IVACost + cart.consTax) > budgetValue" class="text-danger font-weight-bold">
                      ${{ formatter.format(cart.productsCost + cart.IVACost + cart.consTax, 0) }}
                    </span>
                    <span v-if="(cart.productsCost + cart.IVACost + cart.consTax) <= budgetValue" class="text-dark">
                      ${{ formatter.format(cart.productsCost + cart.IVACost + cart.consTax, 0) }}
                    </span>
                  </CCol>
                </CRow>
              </CCol>
              <CCol sm="6" align="center" class="mb-2">
                <CLink 
                  class="btn btn-dark w-50 d-block align-middle p-3 position-relative"
                  :to="redirectUrl"
                  :disabled="cart.items.reduce(((acc, item) => {return Number(acc) + Number(item['cantidad'])}), 0) == 0">
                  <CIcon name="cil-basket" class="m-1"></CIcon>
                  <!-- Canasta {{labelTitle}} -->
                  <p v-if="isQuote">Productos Cotización</p>
                  <span v-if="!isQuote">Canasta Pedido</span>
                  <CBadge  color="light" shape="pill" class="mx-1">{{cart.items.reduce(((acc, item) => {return Number(acc) + Number(item['cantidad'])}), 0)}}</CBadge>
                </CLink>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol sm="3">
        <CInput 
          v-on:keyup="onChange($event, 'search')"
          addLabelClasses="text-muted font-weight-bold" 
          label="Buscar: " 
          :value.sync="search"/>
      </CCol>
      <CCol sm="3">
        <CSelect 
              @change="onChange($event, 'cat')"
              addLabelClasses="text-muted font-weight-bold" 
              label="Categoría: " 
              :options="categories.map(item => { return { value: (item.id_Ciiu).toString(), label: item.descripcion }})"
              :value.sync="selectedCategory"/>
      </CCol>
      <CCol sm="3">
        <CSelect 
              @change="onChange($event, 'subcat')"
              addLabelClasses="text-muted font-weight-bold" 
              label="SubCategoría: " 
              :options="subCategories.map(item => { return { value: (item.id_SubCiiu).toString(), label: item.descripcion }})"
              :value.sync="selectedSubCategory"/>
      </CCol>
      <CCol sm="3">
        <CSelect
              @change="onChange($event, 'brand')" 
              addLabelClasses="text-muted font-weight-bold" 
              label="Marca: " 
              :options="brands.map(item => { return { value: (item.id_Marca).toString(), label: item.marca }})"
              :value.sync="selectedBrand"/>
      </CCol>
    </CRow>
    <CRow class="d-flex align-items-stretch">
            <template 
            v-for="(data, index) in paginatedData">
                <CCol class="d-flex" sm="4" :key="data['id_Producto']">
                    <CCard class="align-self-stretch w-100">
                        <CCardHeader align="center">
                          <span class="font-weight-bold">{{data["descripcion"]}}</span>
                        </CCardHeader>
                        <CCardBody>
                        <div                           
                          class="mx-auto d-block rounded-circle c-avatar" style="width:120px !important; height: 120px !important;">
                          <img 
                              v-if="!data['url_Imagen']"
                              src="../../../public/static/imagen-no-disponible.gif"
                              block
                              class="c-avatar-img"
                          />
                          <URLImgVue v-if="data['url_Imagen']" :url="data['url_Imagen']" class="c-avatar-img"/>
                        </div>
                        <!-- <CIcon 
                          v-if="data['url_Imagen']"
                          :src="data['url_Imagen']" 
                          class="mx-auto d-block rounded-circle" 
                          style="width:120px !important; height: 120px !important;"/> -->

                        </CCardBody>
                        <CCardFooter align="center">
                            <span class="font-weight-bold">{{data["codigo"]}}</span>
                            <p class="font-weight-bold" @dblclick="() => toggleEditPrice(data, index)">${{formatter.format(data["valor_Producto"])}}</p>
                            
                            <div class="d-flex justify-content-center align-items-start" v-if="Boolean(data._toggledEditPrice)">
                              <CInput class="w-75 text-center mx-auto" :value="data['valor_Producto']" @input="newvalue => data['valor_Producto'] = newvalue"/>
                              <CButton size="sm" color="success" @click="()=> {
                                  toggleEditPrice(data, index)
                                }">
                                <CIcon name="cil-check-circle"/>
                              </CButton>
                            </div>
                            <div v-if="cartMode" class="d-inline" >
                              <template v-if="!isQuote">
                                <CButton color="dark" class="badge badge-dark qtyButton" @click="event => removeProductFromCart(event, data)">
                                  <CIcon name="cil-minus" size="sm"/>

                                </CButton>
                                <div class="col-sm-3 d-inline-block w-25" >

                                  <span class="font-weight-bold">{{getItemQuantity(data['id_Producto'])}}</span>
                                </div>
                                  
                                <CButton color="dark" class="badge badge-dark qtyButton" @click="event => addProductToCart(event, data)">
                                  <CIcon name="cil-plus" size="sm"/>
                                </CButton>
                              </template>
                              <input 
                                type="text"
                                class="form-control form-control-sm w-75 text-center mx-auto mb-2" 
                                v-model="data['cantidad']"
                                min="0"
                                v-mask="numbermask"
                                @keyup="value => updateProductQtyInCart(value, data)"
                                v-if="isQuote"/>
                              <p class="font-weight-bold mb-3">Cantidad</p>
                              <CButton
                                color="dark"
                                variant="outline"
                                square
                                size="sm"
                                @click="toggleComments(data, index)"
                                :disabled="getItemQuantity(data['id_Producto']) == 0"
                              >
                                Comentarios
                              </CButton>
                              <CCollapse :show="Boolean(data._toggled)" class="mt-2">
                                  <CTextarea 
                                    v-on:keyup="updateComments($event, data)"
                                    :value="getItemComments(data['id_Producto'])"
                                    :description="(getItemComments(data['id_Producto'])).length+ ' carácteres'"/>
                              
                              </CCollapse>
                            </div>
                        </CCardFooter>
                    </CCard>
                </CCol>
            </template>
    </CRow>
    <CRow>
    <CPagination
      @update:activePage="onChange($event, 'page')"
      v-if="filtered_data.length"
      :activePage.sync="page"
      :pages="totalPages"
      size="sm"
      align="center"
      />
    </CRow>
    <CElementCover  v-show="loading"/>
  </div>
</template>
<style>
  .qtyButton{
    padding: 0 .2rem;
  }
</style>
<script>
  import { formatter } from '@/general';
  import {
    dataListCiius,
    dataListSubCiius
  } from "@/apiDataList";
  import { dataListMarcas } from '@/apiDataList';
  import createNumberMask from 'text-mask-addons/dist/createNumberMask'
  import URLImgVue from './URLImg.vue'

  const numbermask = createNumberMask({
    prefix: '',
    integerLimit: 4,
    allowDecimal: false,
    thousandsSeparatorSymbol: '.',
    includeThousandsSeparator: true,
    allowNegative: false
  })

  export default {
    name: 'ImageGallery',
    data() {
        return {
            page: 1,
            pageSize: 9,
            totalPages: 0,
            categories: [],
            selectedCategory: '',
            subCategories: [],
            dw_subCategories: [],
            selectedSubCategory: '',
            brands: [],
            selectedBrand: '',
            search: '',
            downloaded_data: [],
            filtered_data: [],
            formatter,
            multiplicator: 1,
            doEditPrice: {},
            paginatedData: [],
            innerCollapse: false,
            loading: false,
            numbermask,
            budgetValue: 0
        }
    },
    components: {
      URLImgVue
    },
    props: {
      cartMode: Boolean,
      isQuote: Boolean,
      canEditPrice: Boolean,
      canApplyMultiplicator: Boolean,
      data: Array
    },
    methods: {
      calculateTotalPages(){
        let subTotal = this.filtered_data.length/this.pageSize
        // console.log(subTotal)
        if(subTotal == parseInt(subTotal)){
            this.totalPages = subTotal 
        } else {
            this.totalPages = parseInt(subTotal) + 1 
        }
      },
      onChange(evt, type){
        // console.log(evt.target.value)
        if (type === 'cat') {          
          this.subCategories = (this.dw_subCategories.filter(data => {
            const valCat = this.selectedCategory.length ? data.id_Ciiu == this.selectedCategory : true
            return valCat
          }))
          this.subCategories.unshift({id_SubCiiu: '', descripcion: 'Seleccionar'})
          this.selectedSubCategory = ''
          this.filtered_data = this.downloaded_data.filter(data => {
            // console.log(data.Id_Sub_Ciiu, this.selectedCategory )
            const valCat = this.selectedCategory.length ? data.id_Ciiu === this.selectedCategory : true
            const valSubCat = this.selectedSubCategory.length ? data.id_SubCiiu === this.selectedSubCategory : true
            const valBrand = this.selectedBrand.length ? data.id_Marca === this.selectedBrand : true
            const valSearch = this.search.length ? data.descripcion.toLowerCase().includes(this.search.toLowerCase()) : true
            // console.log(valCat && valSubCat && valBrand && valSearch)
            return valCat && valSubCat && valBrand && valSearch
          })
        }

        if (type === 'subcat') {
          console.log(evt.target.value, this.selectedSubCategory )
          this.filtered_data = this.downloaded_data.filter(data => {
            const valCat = this.selectedCategory.length ? data.id_Ciiu === this.selectedCategory : true
            const valSubCat = evt.target.value.length ? data.id_SubCiiu === evt.target.value : true
            const valBrand = this.selectedBrand.length ? data.id_Marca === this.selectedBrand : true
            const valSearch = this.search.length ? data.descripcion.toLowerCase().includes(this.search.toLowerCase()) : true
            // console.log(valCat && valSubCat && valBrand && valSearch)
            return valCat && valSubCat && valBrand && valSearch
          })
        }

        if (type === 'brand') {
          this.filtered_data = this.downloaded_data.filter(data => {
            // console.log(data.Id_Sub_Ciiu, this.selectedCategory )
            const valCat = this.selectedCategory.length ? data.id_Ciiu === this.selectedCategory : true
            const valSubCat = this.selectedSubCategory.length ? data.id_SubCiiu === this.selectedSubCategory : true
            const valBrand = evt.target.value.length ? data.id_Marca === evt.target.value : true
            const valSearch = this.search.length ? data.descripcion.toLowerCase().includes(this.search.toLowerCase()) : true
            // console.log(valCat && valSubCat && valBrand && valSearch)
            return valCat && valSubCat && valBrand && valSearch
          })
        }

        if (type === 'search') {
          this.filtered_data = this.downloaded_data.filter(data => {
            // console.log(data.Id_Sub_Ciiu, this.selectedCategory )
            const valCat = this.selectedCategory.length ? data.id_Ciiu === this.selectedCategory : true
            const valSubCat = this.selectedSubCategory.length ? data.id_SubCiiu === this.selectedSubCategory : true
            const valBrand = this.selectedBrand.length ? data.id_Marca === this.selectedBrand : true
            const valSearch = evt.target.value.length ? data.descripcion.toLowerCase().includes(evt.target.value.toLowerCase()) : true
            // console.log(valCat && valSubCat && valBrand && valSearch)
            return valCat && valSubCat && valBrand && valSearch
          })
        }

        if (type === 'page') {
          this.filtered_data = this.downloaded_data.filter(data => {
            // console.log(data.Id_Sub_Ciiu, this.selectedCategory )
            const valCat = this.selectedCategory.length ? data.id_Ciiu === this.selectedCategory : true
            const valSubCat = this.selectedSubCategory.length ? data.id_SubCiiu === this.selectedSubCategory : true
            const valBrand = this.selectedBrand.length ? data.id_Marca === this.selectedBrand : true
            const valSearch = this.search.length ? data.descripcion.toLowerCase().includes(this.search.toLowerCase()) : true
            // console.log(valCat && valSubCat && valBrand && valSearch)
            return valCat && valSubCat && valBrand && valSearch
          })
        }
        
        this.calculateTotalPages()
      },
      updateProductPriceInCart(product){
        this.$store.dispatch('updateProductPriceInCart', product)
      },
      updateProductQtyInCart(domElement, product){  
        // console.log(domElement.target.value, product)      
        this.$store.dispatch('updateProductQtyInCart', {
          ...product,
          'cantidad': domElement.target.value ? parseInt(domElement.target.value) : 0
        })
      },
      addProductToCart(event, product){
        event.stopPropagation()
        console.log('addProductToCart')
        this.$store.dispatch('addProductToCart', product)
      },
      removeProductFromCart(event, product){
        event.stopPropagation()
        console.log('removeProductFromCart')        
        this.$store.dispatch('removeProductFromCart', product)
      },
      getItemQuantity(product_id){
        return this.$store.getters.getItemQuantity(product_id)
      },
      getItemComments(product_id){
        return this.$store.getters.getItemComments(product_id)
      },
      updateComments(event, product){
  
        const text_size = (event.target._value.toString()).length
        if (text_size > 500) {
          this.$store.commit('updateItemComments', [
                      (event.target._value.toString()).slice(0, 500),
                      product
                  ])
          
        } else {
          
          this.$store.commit('updateItemComments', [
                      event.target._value,
                      product
                  ])
        }
      },
      toggleComments(item){
        const sItem = this.filtered_data.find(product => item['id_Producto'] === product['id_Producto'])
        this.$set(sItem, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      toggleEditPrice(item){
        
        if(!this.canEditPrice) return

        this.$set(item, '_toggledEditPrice', !item._toggledEditPrice)
        this.$nextTick(() => { 
          this.updateProductPriceInCart(item)
         })
        
      },
      itemQuantity(product_id){
        const itemInCart = this.$store.state.cart.items.find(item => item["id_Producto"] == product_id)
        if(itemInCart){
          if (itemInCart["cantidad"]) {
            return itemInCart["cantidad"]
          } else {
            itemInCart["cantidad"] = 0
            return 0
          }
        } else {
          return 0
        }
      },
      itemPrice(product_id){
        const itemInCart = this.$store.state.cart.items.find(item => item["id_Producto"] == product_id)
        if(!itemInCart) return ''
        if (itemInCart["valor_Producto"]) {
          return itemInCart["valor_Producto"]
        }
      }
    },
    async mounted() {
      dataListCiius(this).then(data => { 
        data.unshift({id_Ciiu: '', descripcion: 'Seleccionar'})
        this.categories = data 
      })

      dataListSubCiius(this).then(data => { 
        this.subCategories = [...data] 
        this.dw_subCategories = [...data]  
        this.subCategories.unshift({id_SubCiiu: '', descripcion: 'Seleccionar'})
      })
      
      dataListMarcas(this).then(data => { 
        data.unshift({id_Marca: '', marca: 'Seleccionar'})
        this.brands = data 
      })

      if(this.$store.state.user.type === 'E') return
      if (this.$store.state.user.dependency.id_Dependencia.length == 0 && this.cartMode) {
        this.$store.commit(
          'setAlert',
          {
            color: 'warning',
            message: 'No se seleccionó una Dependencia, por favor seleccionarla',
            show: 5
          }
        )
        this.$router.push({path:'/cliente'})
      } else {
        this.budgetValue = this.$store.state.user.dependency.valorPresupuesto
      }
    },
    computed: {
      cart(){
        return this.$store.state.cart
      },
      redirectUrl(){
        return this.isQuote ? "/empresa/movimientos/cotizaciones/confirmacioncotizacion" : "/cliente/movimientos/pedidos/procesamientoPedido"
      },
      labelTitle(){
        return this.isQuote ? "Cotización" : "Pedido"
      }
    },
    watch:{
      data(){
        this.data.forEach(element => {
          element['cantidad'] = this.itemQuantity(element['id_Producto'])
          element['valor_Producto'] = this.itemPrice(element['id_Producto']) ? this.itemPrice(element['id_Producto']) : element['valor_Producto']
        });
        this.downloaded_data = this.filtered_data = this.data
        
      },
      filtered_data(){
        this.totalPages ? null : this.calculateTotalPages()
        const start = (this.page - 1) * this.pageSize
        this.paginatedData = this.filtered_data.slice(
          start, 
          start + this.pageSize
        )
        this.paginatedData.forEach((product) => this.doEditPrice[product['id_Producto']] = false)
      }
    }
  }
</script>